import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { QuickRegisterOpener } from '@libs/util-services';
import { QuickRegisterModalComponent } from './quick-register-modal.component';

/** Implementação concreta do QUICK_REGISTER_OPENER — ver o token. */
@Injectable({ providedIn: 'root' })
export class LessorQuickRegisterOpener implements QuickRegisterOpener {
  private readonly modalCtrl = inject(ModalController);

  async open(): Promise<string | null> {
    const modal = await this.modalCtrl.create({
      component: QuickRegisterModalComponent,
      cssClass: 'modal-fullscreen',
    });
    await modal.present();
    const { data } = await modal.onWillDismiss<string | null>();
    return typeof data === 'string' && data ? data : null;
  }
}
